/**
 * shabbatZmanUtils.js — עזר לתצוגת כלל הזמן בזמני שבת
 */

const SHABBAT_ZMAN_LABELS = {
  // sentinel keys
  dayEntryTime:      'כניסת שבת',
  dayExitTime:       'צאת שבת',
  // calendar events
  candleLighting:    'הדלקת נרות',
  havdalah:          'הבדלה',
  shabbatHavdalah:   'צאת שבת',
  dayHavdalah:       'הבדלה',
  // friday-specific
  fridaySunset:      'שקיעה - שישי',
  fridayTzeit85:     "צאת כוכבים - שישי",
  fridayTzeit7083:   "צאת ר״ת - שישי",
  fridayTzeit42:     "צאת 42 דק׳ - שישי",
  fridayTzeit50:     "צאת 50 דק׳ - שישי",
  fridayTzeit72:     "צאת 72 דק׳ - שישי",
  // shabbat-specific
  shabbatSunset:     'שקיעה - שבת',
  shabbatTzeit85:    "צאת כוכבים - שבת",
  shabbatTzeit7083:  "צאת ר״ת - שבת",
  shabbatTzeit42:    "צאת 42 דק׳ - שבת",
  shabbatTzeit50:    "צאת 50 דק׳ - שבת",
  shabbatTzeit72:    "צאת 72 דק׳ - שבת",
  // day* keys (context-dependent)
  daySunset:         'שקיעה',
  dayNetz:           'הנץ',
  dayAlot:           'עלות השחר',
  dayChatzot:        'חצות',
  dayPlagHamincha:   'פלג המנחה',
  dayMinchaGedola:   'מנחה גדולה',
  dayMinchaKetana:   'מנחה קטנה',
  dayTzeit85:        'צאת כוכבים',
  dayTzeit7083:      'צאת ר״ת',
  dayTzeit42:        "צאת 42 דק׳",
  dayTzeit50:        "צאת 50 דק׳",
  dayTzeit72:        "צאת 72 דק׳",
  daySofZmanShma:    'סוף זמן שמע',
  daySofZmanShmaMga: 'סוף זמן שמע מג"א',
  // older keys
  sofZmanShma:       'סוף זמן שמע',
  sofZmanShmaMga:    'סוף זמן שמע מג"א',
};

/**
 * מחזיר תיאור קצר של כלל הזמן עבור ct (custom time).
 * - fixed  → 'שעה קבועה'
 * - relative, offset=0 → שם הזמן
 * - relative, offset≠0 → 'X דק׳ לפני/אחרי [שם]'
 * מחזיר null אם אין מידע.
 */
const formatDuration = (abs) => {
  if (abs < 60) return `${abs} דק׳`;
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  const hoursStr = hours === 1 ? 'שעה' : `${hours} שעות`;
  if (mins === 0) return hoursStr;
  return `${hoursStr} ו${mins} דק׳`;
};

export const formatShabbatTimeRule = (ct) => {
  if (!ct) return null;
  if (ct.type === 'fixed') return 'קבוע';
  if (ct.type === 'relative') {
    const baseTime = ct.baseTime || '';
    const label = baseTime.startsWith('ct:')
      ? (ct._baseLabel || '')
      : (SHABBAT_ZMAN_LABELS[baseTime] || baseTime || '');
    const offset = parseInt(ct.offset) || 0;
    if (offset === 0) return label;
    const abs = Math.abs(offset);
    const dur = formatDuration(abs);
    return offset < 0 ? `${dur} לפני ${label}` : `${dur} אחרי ${label}`;
  }
  return null;
};
